const getSizeWithUnit = (size, defaultValue) => {
  if (!size) {
    return defaultValue
  }

  return `${size}px`
}

export { getSizeWithUnit }
